var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "mb-2",
          attrs: { color: "primary", dark: "", elevation: "0" }
        },
        [
          _c("span", [_vm._v("New Supplier")]),
          _c("v-spacer"),
          _c("v-icon", [_vm._v("mdi-account")]),
          _c("v-icon", [_vm._v("mdi-plus")])
        ],
        1
      ),
      _vm.splrPostSuccess
        ? _c("v-alert", { attrs: { type: "success", dismissible: "" } }, [
            _c("span", [_vm._v(_vm._s(_vm.splrPostSuccess))])
          ])
        : _vm._e(),
      _vm._l(_vm.splrPostErrors, function(item, index) {
        return _c(
          "v-alert",
          { key: index, attrs: { type: "error", dismissible: "" } },
          [
            _c("span", { staticClass: "text-uppercase" }, [
              _vm._v(_vm._s(item.first()))
            ])
          ]
        )
      }),
      _c(
        "v-row",
        { staticClass: "px-2" },
        [
          _c(
            "v-col",
            {
              staticClass: "pb-0",
              attrs: { "offset-lg": "6", lg: "3", cols: "12" }
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Supplier ID",
                  value: _vm.supplierId,
                  readonly: "",
                  outlined: true,
                  dense: true
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function() {
                      return [
                        !_vm.newSupplierIdGetting
                          ? _c(
                              "v-icon",
                              {
                                attrs: { color: "primary" },
                                on: { click: _vm.getNewSupplierId }
                              },
                              [_vm._v("mdi-refresh")]
                            )
                          : _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                color: "primary",
                                width: "2",
                                size: "18",
                                value: true
                              }
                            })
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pb-0", attrs: { lg: "3", cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Category",
                  items: _vm.splrCatList,
                  "item-value": "id",
                  loading: _vm.splrCatGetting,
                  outlined: true,
                  dense: true
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text mr-2" }, [
                          _vm._v(_vm._s(item.id))
                        ]),
                        _c("span", { staticClass: "grey--text caption" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ]
                    }
                  },
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text mr-2" }, [
                          _vm._v(_vm._s(item.id))
                        ]),
                        _c("span", { staticClass: "grey--text caption" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.supplierCategoryId,
                  callback: function($$v) {
                    _vm.supplierCategoryId = $$v
                  },
                  expression: "supplierCategoryId"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Company Name", outlined: true, dense: true },
                model: {
                  value: _vm.companyName,
                  callback: function($$v) {
                    _vm.companyName = $$v
                  },
                  expression: "companyName"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Bussiness Phone",
                  outlined: true,
                  dense: true
                },
                model: {
                  value: _vm.businessPhone,
                  callback: function($$v) {
                    _vm.businessPhone = $$v
                  },
                  expression: "businessPhone"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Fax Number", outlined: true, dense: true },
                model: {
                  value: _vm.faxNumber,
                  callback: function($$v) {
                    _vm.faxNumber = $$v
                  },
                  expression: "faxNumber"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Country", outlined: true, dense: true },
                model: {
                  value: _vm.country,
                  callback: function($$v) {
                    _vm.country = $$v
                  },
                  expression: "country"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Postal Code", outlined: true, dense: true },
                model: {
                  value: _vm.postalCode,
                  callback: function($$v) {
                    _vm.postalCode = $$v
                  },
                  expression: "postalCode"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "City", outlined: true, dense: true },
                model: {
                  value: _vm.city,
                  callback: function($$v) {
                    _vm.city = $$v
                  },
                  expression: "city"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Province", outlined: true, dense: true },
                model: {
                  value: _vm.province,
                  callback: function($$v) {
                    _vm.province = $$v
                  },
                  expression: "province"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Region", outlined: true, dense: true },
                model: {
                  value: _vm.region,
                  callback: function($$v) {
                    _vm.region = $$v
                  },
                  expression: "region"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "9", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Address", outlined: true, dense: true },
                model: {
                  value: _vm.address,
                  callback: function($$v) {
                    _vm.address = $$v
                  },
                  expression: "address"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  label: "Notes",
                  "auto-grow": "",
                  clearable: "",
                  outlined: "",
                  rows: "5",
                  "no-resize": ""
                },
                model: {
                  value: _vm.notes,
                  callback: function($$v) {
                    _vm.notes = $$v
                  },
                  expression: "notes"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", loading: _vm.splrPosting },
                  on: { click: _vm.storeSupplier }
                },
                [_c("span", [_vm._v("Save")])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }